import { createQueryData } from '../helpers/createQueryData';

const { useQuery } = createQueryData({
  endPoint: 'Acceptance/get_related_addresses',
  options: { arrayFormat: 'comma' },
});

export const useRelatedAddresses = ({
  params: { serviceCompanyId, addressId, houseIds } = {},
  options,
} = {}) =>
  useQuery({
    params: { serviceCompanyId, addressId, houseIds },
    options: {
      enabled: Boolean(serviceCompanyId && addressId && houseIds),
      ...options,
    },
  });
